export { BacsUploadHeader } from './BacsUploadHeader';
export { connectWrapper as BacsUploadBody } from './BacsUploadBody';
export { contentWrapper as BacsUploadFooter } from './BacsUploadFooter';

export const getPageTotal = (importedPaymentsData) =>
	importedPaymentsData.reduce((accumulator, data) => {
		const amount = Number(data.amount.replace(/,/g, ''));
		return accumulator + (Number.isNaN(amount) ? 0 : amount);
	}, 0);
